import axios from "./../../config/axios";

function calculateDifference(year) {
    return axios().get("/ledger/exchange-difference?year=" + year);
}

export default {
    calculateDifference
}